import React from "react";

export default class UploadImage extends React.Component {
  state = {
    showDelete: false,
    filename: "No Files Attached",
    files: null,
    bitmap: null,
  };

  inputChanged(value) {
    if (this.props.withPreviewer) {
      var fr = new FileReader();
      let setPreviewerImage = this.props.setPreviewerImage;
      fr.onload = function() {
        setPreviewerImage(fr.result);
      };
      fr.readAsDataURL(document.getElementById(this.props.id).files[0]);
    }

    if (this.props.type === "profileImage") {
      this.setState({
        filename: document.getElementById(this.props.id).files.length,
        profileImage: document.getElementById(this.props.id).files[0],
        showDelete: true,
      });

      this.props.self.setState({
        profileImage: document.getElementById(this.props.id).files[0],
      });
    } else {
      this.setState({
        filename: document.getElementById(this.props.id).files.length,
        files: document.getElementById(this.props.id).files,
        showDelete: true,
      });
      this.props.self.setState({
        filename: document.getElementById(this.props.id).files.length,
        files: document.getElementById(this.props.id).files,
      });
    }
  }

  removeAttachment() {
    if (this.props.withPreviewer) {
      let setPreviewerImage = this.props.setPreviewerImage;
      setPreviewerImage(null);
    }

    document.getElementById(this.props.id).value = "";

    if (this.props.type === "profileImage") {
      this.setState({
        filename: "No Files Attached",
        profileImage: null,
        showDelete: false,
      });

      this.props.self.setState({
        profileImage: null,
      });
    } else {
      this.setState({
        filename: "No Files Attached",
        files: null,
        showDelete: false,
      });
      this.props.self.setState({
        filename: "No Files Attached",
        files: null,
      });
    }
  }

  render() {
    return (
      <div
        style={{
          width: 250,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        className="input-group"
      >
        <div className="custom-file">
          <input
            type="file"
            onChange={(value) => this.inputChanged(value)}
            className="custom-file-input"
            id={this.props.id}
            aria-describedby="inputGroupFileAddon01"
            multiple={this.props.multiple}
            accept={this.props.accept}
          />
          <label className="custom-file-label" htmlFor={this.props.id}>
            {this.state.filename === "No Files Attached"
              ? this.state.filename
              : this.state.filename === 1
              ? "1 File Attached"
              : this.state.filename + " Files Attached"}
          </label>
        </div>
        <div
          onClick={() => this.removeAttachment()}
          style={{
            opacity: this.state.showDelete ? 1 : 0,
            marginLeft: 16,
            backgroundColor: "lightgrey",
            width: 20,
            height: 20,
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 10,
          }}
        >
          X
        </div>
      </div>
    );
  }
}
